import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: { margin: '16px 0' },
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '10fr 10fr 6fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    color: theme.palette.text.secondary,
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,

    borderRadius: 12,
    alignItems: 'center'
  },
  roleRowRoot: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '26fr 1fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    textAlign: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },

  tableRow: {
    display: 'grid',
    gridTemplateColumns: '10fr 10fr 6fr',
    height: 100,
    alignItems: 'center',

    width: '100%',
    textAlign: 'unset'
  },
  tableRowSkeleton: {
    display: 'grid',
    gridTemplateColumns: '10fr 10fr 6fr 1fr',
    height: 100,
    alignItems: 'center',

    width: '100%',
    textAlign: 'unset'
  },
  tableRowSkeletonForMobile: {
    height: 60
  },
  tableRowMobile: {
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    cursor: 'initial',
    paddingLeft: 12,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  userLogo: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: '#dfdfdf',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12
  },
  nameCell: {
    display: 'flex'
  },
  moreIcon: {
    cursor: 'pointer'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  editButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '80%'
  },
  skeletonForEdit: {
    width: '40%',
    marginRight: 24
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  },
  EditIcon: {
    fontSize: 18,
    marginRight: 12
  }
}))

export default useStyles
